import { O } from "../../../features/ui";
import { Area } from "../../administration";
import { UserRole } from "../state/types";

export const getAreaFromRole = (role: UserRole): O<Area> => {
    return new Map<UserRole, Area>()
        .set(UserRole.MANAGER, Area.MANAGMENT)
        .set(UserRole.LOGISTICS, Area.LOGISTICS)
        .set(UserRole.ADMINISTRATION, Area.ADMINISTRATION)
        .set(UserRole.PURCHASES, Area.PURCHASES)
        .set(UserRole.SALES, Area.SALES)
        .set(UserRole.WAREHOUSE, Area.WAREHOUSE)
        .get(role)
}
